import styles from "./style.module.css";
import React from "react";
import { gray1, gray5, white } from "assets/styleUtils";
import parse from "html-react-parser";

export default function PopupModal({
  title,
  sub,
  closePopupToday,
  close,
}: {
  title: string;
  sub: string;
  closePopupToday?: () => void;
  close?: () => void;
}) {
  return (
    <div className={styles.modalStyle}>
      <div style={{ width: "100%", padding: "24px 10px", paddingTop: "32px" }}>
        <p className={styles.textStyle}>{title}</p>
        <p
          style={{
            lineHeight: "25px",
            textAlign: "center",
            whiteSpace: "pre-line",
            height: "300px",
            overflowY: "scroll",
          }}
        >
          {parse(sub)}
        </p>
      </div>
      <div style={{ width: "300px", height: "48px", display: "flex" }}>
        <button
          onClick={closePopupToday}
          style={{
            flex: 2,
            color: gray1,
            fontSize: "14px",
            fontWeight: 500,
            border: `1px solid ${gray5}`,
          }}
        >
          오늘 하루 보지 않기
        </button>
        <button
          onClick={close}
          style={{
            flex: 1,
            backgroundColor: gray1,
            color: white,
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
}
